/* ============================================================
   ADMIN — urus Partner  (/admin/partners · PLAN_PARTNER.md skrin 5)
   ============================================================
   Admin sahaja (route dibalut AdminPinGate; server menyemak ADMIN_EMAILS).
   Tambah Partner ikut email akaun SESAAT · Suspend / Activate · Reset PIN.

   ⚠️ Setiap butang di sini MENULIS ke data production (`partners/`).
      Tiada data pelanggan lain disentuh. Partner TIDAK mendapat lesen,
      module rasmi, atau akses admin — hanya Partner Studio (/partner).
   ============================================================ */
import { useCallback, useEffect, useState } from 'react';
import { Loader2, RefreshCw } from 'lucide-react';
import '../design/tokens.css';
import { Btn, Badge, PageHeader, EmptyState } from '../design/ui';
import { panggilPartner, masaLalu } from '../services/partnerStudioService';
import AdminPartnerReview from './AdminPartnerReview';
import AdminPartnerButiran from './AdminPartnerButiran';

export default function AdminPartnerView() {
    const [senarai, setSenarai] = useState(null);
    const [menunggu, setMenunggu] = useState([]);
    const [semak, setSemak] = useState(null); // item menunggu yang sedang di-review
    const [lihat, setLihat] = useState(null); // Partner yang sedang dilihat (semua kerjanya)
    const [hadLab, setHadLab] = useState(100);
    const [email, setEmail] = useState('');
    const [sibuk, setSibuk] = useState('');
    const [mesej, setMesej] = useState({ jenis: '', teks: '' });

    const muat = useCallback(async () => {
        try {
            const h = await panggilPartner('adminSenarai');
            setSenarai(h.partners);
            setMenunggu(h.menunggu || []);
            setHadLab(h.hadLab);
        } catch (e) {
            setSenarai([]);
            setMesej({ jenis: 'ralat', teks: e?.message || 'Could not load partners.' });
        }
    }, []);
    useEffect(() => { muat(); }, [muat]);

    const buat = async (kunci, fn, berjaya) => {
        setSibuk(kunci); setMesej({ jenis: '', teks: '' });
        try {
            await fn();
            setMesej({ jenis: 'ok', teks: berjaya });
            await muat();
        } catch (e) {
            setMesej({ jenis: 'ralat', teks: e?.message || 'Action failed.' });
        } finally { setSibuk(''); }
    };

    const tambah = () => {
        const e = email.trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) { setMesej({ jenis: 'ralat', teks: 'Enter a valid email.' }); return; }
        buat('tambah', async () => { await panggilPartner('adminTambah', { email: e }); setEmail(''); },
            `${e} added. They can open /partner and create their PIN.`);
    };
    const tukarStatus = (p) => {
        const baru = p.status === 'aktif' ? 'digantung' : 'aktif';
        if (baru === 'digantung' && !window.confirm(`Suspend ${p.email}? They'll be signed out of Partner Studio right away. Their modules are kept.`)) return;
        buat(p.uid, () => panggilPartner('adminStatus', { uid: p.uid, status: baru }),
            baru === 'digantung' ? `${p.email} suspended.` : `${p.email} activated.`);
    };
    const resetPin = (p) => {
        if (!window.confirm(`Reset PIN for ${p.email}? They'll create a new PIN the next time they open Partner Studio.`)) return;
        buat(p.uid, () => panggilPartner('adminResetPin', { uid: p.uid }), `PIN reset for ${p.email}.`);
    };

    if (lihat) {
        return (
            <div className="s-root" style={{ minHeight: '100%', height: '100%', overflowY: 'auto', background: 'var(--s-ground)' }}>
                <div style={{ maxWidth: 1080, margin: '0 auto', padding: '24px 16px 48px' }}>
                    <AdminPartnerButiran
                        key={lihat.uid}
                        partner={lihat}
                        onKembali={() => { setLihat(null); muat(); }}
                        onSelesai={(teks) => { setLihat(null); setMesej({ jenis: 'ok', teks }); muat(); }}
                    />
                </div>
            </div>
        );
    }

    if (semak) {
        return (
            <div className="s-root" style={{ minHeight: '100%', height: '100%', overflowY: 'auto', background: 'var(--s-ground)' }}>
                <div style={{ maxWidth: 1080, margin: '0 auto', padding: '24px 16px 48px' }}>
                    <AdminPartnerReview
                        key={`${semak.uid}/${semak.modId}/${semak.versi}`}
                        item={semak}
                        onKembali={() => setSemak(null)}
                        onSelesai={(teks) => { setSemak(null); setMesej({ jenis: 'ok', teks }); muat(); }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="s-root" style={{ minHeight: '100%', height: '100%', overflowY: 'auto', background: 'var(--s-ground)' }}>
            <div style={{ maxWidth: 960, margin: '0 auto', padding: '24px 16px 48px' }}>
                <PageHeader
                    title="Partners"
                    subtitle="People who build their own modules in Partner Studio (/partner). They don't get admin access or free licenses."
                    suisBahasa={false}
                    actions={<Btn size="sm" variant="ghost" icon={<RefreshCw size={14} />} onClick={muat}>Refresh</Btn>}
                />
                <div className="s-card" style={{ marginBottom: 14 }}>
                    <div className="s-sect">
                        <span className="s-lbl" style={{ margin: 0 }}>Add partner</span>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <input className="s-input" style={{ flex: 1, minWidth: 220 }} type="email" placeholder="partner@gmail.com" value={email}
                                onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') tambah(); }} />
                            <Btn size="sm" onClick={tambah} disabled={sibuk === 'tambah'}>{sibuk === 'tambah' ? 'Adding…' : 'Add partner'}</Btn>
                        </div>
                        <p className="s-hint" style={{ margin: 0 }}>The email must already have a SESAAT account. Before adding, make sure their Gmail has 2-Step Verification on.</p>
                        {mesej.teks && <p className="s-hint" style={{ margin: 0, color: mesej.jenis === 'ralat' ? 'var(--s-stop)' : 'var(--s-ok)' }}>{mesej.teks}</p>}
                    </div>
                </div>

                {menunggu.length > 0 && (
                    <div className="s-card" style={{ marginBottom: 14 }}>
                        <div className="s-sect" style={{ gap: 0 }}><span className="s-lbl" style={{ margin: 0 }}>Waiting for review ({menunggu.length})</span></div>
                        <div className="s-list">
                            {menunggu.map((r) => (
                                <div key={`${r.uid}/${r.modId}`} className="s-list__row" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 16px', flexWrap: 'wrap' }}>
                                    <div style={{ flex: 1, minWidth: 200 }}>
                                        <div className="s-cardname">{r.nama} <span className="s-dim" style={{ fontSize: 12, fontWeight: 400 }}>· {r.email}</span></div>
                                        <div className="s-dim" style={{ fontSize: 12 }}>
                                            {r.modulRasmiId ? `Update to approved module ${r.modulRasmiId} · version ${r.versi} (live: version ${r.versiLulus})` : `New module · version ${r.versi}`} · sent {masaLalu(r.dihantarPada)}
                                        </div>
                                    </div>
                                    <Btn size="sm" onClick={() => { setMesej({ jenis: '', teks: '' }); setSemak(r); }}>Review</Btn>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {senarai === null ? (
                    <p className="s-hint"><Loader2 size={14} className="animate-spin" style={{ verticalAlign: -2 }} /> Loading…</p>
                ) : senarai.length === 0 ? (
                    <EmptyState title="No partners yet">Add a partner by email above.</EmptyState>
                ) : (
                    <div className="s-card">
                        <div className="s-list">
                            {senarai.map((p) => (
                                <div key={p.uid} className="s-list__row" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 16px', flexWrap: 'wrap' }}>
                                    <div style={{ flex: 1, minWidth: 200 }}>
                                        <div className="s-cardname">{p.email}</div>
                                        <div className="s-dim" style={{ fontSize: 12 }}>
                                            {p.bilModul} {p.bilModul === 1 ? 'module' : 'modules'} · {p.ujianHariIni} / {hadLab} tests today · {p.pinAda ? 'PIN set' : 'PIN not created yet'}
                                            {p.ditambahPada ? ` · added ${masaLalu(p.ditambahPada)}` : ''}
                                        </div>
                                    </div>
                                    <Badge tone={p.status === 'aktif' ? 'ok' : 'stop'}>{p.status === 'aktif' ? 'Active' : 'Suspended'}</Badge>
                                    <Btn size="sm" variant="quiet" disabled={!!sibuk || !p.pinAda} onClick={() => resetPin(p)}>Reset PIN</Btn>
                                    <Btn size="sm" variant="ghost" disabled={!!sibuk} onClick={() => tukarStatus(p)}>{p.status === 'aktif' ? 'Suspend' : 'Activate'}</Btn>
                                    <Btn size="sm" onClick={() => { setMesej({ jenis: '', teks: '' }); setLihat({ uid: p.uid, email: p.email }); }}>View</Btn>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
